<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content>
			<template #content>
				<div class="columns column6">
					<h1>{{ page.title || page.header }}</h1>
					<p v-if="page.bookingID">
						<a
							v-if="page.bookingID"
							class="button cta"
							target="_blank"
							rel="noopener noreferrer"
							:href="
								'https://onlinebookingengine.vipscloudpms.com/EB6A1D63-4588-47C2-B3B2-3D04A1D51F67/home?&roomtypeid=' +
								page.bookingID +
								'&language=' +
								locale
							"
						>
							{{ $t('bookThisRoom') }}
						</a>
						<book-button v-else class="button cta">
							{{ $t('bookThisRoom') }}
						</book-button>
					</p>
				</div>
				<div class="columns column6">
					<div v-parse-links v-html="page.content" />
				</div>
			</template>
		</main-content>

		<section class="main-content room-info">
			<div class="row background-light">
				<div class="columns column12 align-center">
					<h2>{{ $t('aboutThisRoom') }}</h2>
				</div>
				<div class="columns column8">
					<h3>{{ $t('facilities') }}</h3>
					<div class="room-icons">
						<div v-for="facility in page.facilities" :key="facility.id" class="icon-holder">
							<font-awesome-icon :icon="`fal fa-${facility.icon}`" size="1x" />
							<span>{{ facility.content }}</span>
						</div>
					</div>
				</div>
				<div class="columns column4">
					<div v-parse-links v-html="page.extraContent" />
				</div>
			</div>
		</section>

		<section class="main-content gallery-section">
			<div class="row">
				<div v-for="(item, index) in page.images" :key="index" class="columns column4">
					<picture>
						<source v-if="item.imagesWebp" :srcset="item.imagesWebp" type="image/webp" />
						<source :srcset="item.images" />
						<img :src="item.image" :alt="item.imageAlt" loading="lazy" />
					</picture>
				</div>
			</div>
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { locale } = useI18n();
const { page, fetchPage } = usePage();

await fetchPage();
</script>

<style lang="scss" scoped>
.main-content {
	:deep(ul) {
		padding: 0 0 0 20px;
	}

	:deep(li) {
		width: 50%;
		float: left;
	}
}

.room-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;
	margin: 0 0 40px;
}

.icon-holder {
	color: $subtitle-color;
	width: 32%;
	margin: 10px 0;

	i,
	svg {
		margin: 0 5px 0 0;
	}
}

.room-item .room-icons {
	max-width: 600px;
}

.room-info {
	padding: 0;

	.row {
		padding: 50px 30px;

		ul {
			padding-left: 20px;
		}
	}
}

.gallery-section {
	.row {
		display: flex;
		flex-flow: row wrap;
		justify-content: flex-start;
		align-items: center;

		.columns {
			margin: 15px 0;
		}
	}
}

.gallery-section img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 50px 30px;
	}

	.room-info .column12 {
		text-align: left;
	}
}

@media (max-width: 680px) {
	.icon-holder {
		width: 49%;
	}
}
</style>
